import Tooltip from "../Tooltip/Tooltip";

const Card = (props) => {
  return (
    <div className="max-w-sm overflow-hidden shadow-md duration-200 hover:scale-105 hover:shadow-xl">
      <div className="flex justify-center border-1 cursor-pointer ">
        <img
          src={props.img_src}
          alt={props.title}
          //   className="h-72 w-52 object-fit"
          className="h-72 w-72 object-cover rounded-lg"
        />
      </div>
      <div className="p-8">
        <div className="flex justify-center">
          <span className="text-lg mb-5 text-white text-center">
            {props.title}
          </span>
          <img
              src="/images/information.png"
              className="w-5 h-5 ml-3 cursor-pointer"
              alt="information icon"
            />
          {/* <Tooltip text={props.toolTip}>
            
          </Tooltip> */}
        </div>

        <a href={props.buttonURL} className="flex space-x-2 justify-center">
          <button
            type="button"
            className="inline-block border-2 px-6 py-2 border-indigo-600 text-white font-medium hover:font-semibold lg:text-md text-sm uppercase rounded-md hover:bg-indigo-600 cursor-pointer"
          >
            Go to Page
          </button>
        </a>
      </div>
    </div>
  );
};

export default Card;
